exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pact_wrap[data-v-268477d8]{width:1200px;margin:0 auto;margin-top:50px;padding:20px;border:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-268477d8","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/edit/pact3.vue
// module id = 357
// module chunks = 0